import styles from './accountdetails.module.css';
import ReminderComponent from '../ReminderComponent'
import InteractionComponent from '../InteractionComponent'
import AccountDetailsDetails from './AccountDetailsDetails';
import AccountDetailsSquare from './AccountDetailsSquare';
import { useGetAccountOwner } from '../../api/auth/useGetAccountOwner';
import { useGetLeadDetailsSquare } from '../../api/lead/useGetLeadDetailsSquare';

const AccountDetailContainerWrapper = ({leadID}) => {
  const accountOwner = useGetAccountOwner({leadID: leadID});
  const {leadDetails} = useGetLeadDetailsSquare({leadId: leadID})

  return (
    <div className={styles.wrapper}>
        <AccountDetailsSquare leadDetails={leadDetails} />
        <AccountDetailsDetails accountOwner={accountOwner} leadID={leadID}/>
        <div className='flex flex-col md:flex-row md:justify-between w-full gap-4 md:gap-0 mr-0 md:mr-5 px-2 sm:px-0'>
          <ReminderComponent leadID={leadID} owner={accountOwner}/>
          <InteractionComponent leadID={leadID} owner={accountOwner}/>
        </div>
    </div>
  );
}

export default AccountDetailContainerWrapper;